import React from 'react';
import { Menu, MenuButton, Button, useDisclosure, Text, } from '@chakra-ui/react';
import { localise } from '../../../services/lang/lang';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
import { useTokens } from '../../../context/TokenProvider';
import { removeTagsFromSmartText } from '../SmartText/SmartText';
import CustomSelectOptions from './CustomSelectOptions';
const CustomSelect = ({ groups, value, onChange, isDisabled = false, isInvalid = false, nameField, testId, ...rest }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const tokens = useTokens();
    if (groups.length > 1 && !groups.every((group) => !!group.key)) {
        throw new Error('Key must be provided for every group if there are multiple');
    }
    const flatOptions = groups.flatMap((group) => group.options);
    const selectedOption = (() => {
        if (value && typeof value === 'object') {
            const group = groups.find((g) => g.key === value.key);
            if (!group)
                return;
            return group.options.find((option) => option.id === value.id);
        }
        return flatOptions.find((option) => option.id === value);
    })();
    const defaultText = flatOptions.length
        ? localise('SELECT_OPTION')
        : localise('NO_OPTIONS_AVAILBLE');
    const styleOverride = isInvalid
        ? {
            borderColor: tokens.BorderError,
            borderWidth: tokens.BorderWidth02,
        }
        : undefined;
    return (React.createElement(Menu, { variant: "select", isOpen: isOpen, onClose: onClose, onOpen: onOpen },
        React.createElement(MenuButton, { as: Button, variant: "select", w: "full", "data-testid": testId || 'custom_select__button', sx: styleOverride, isDisabled: isDisabled || !flatOptions.length, rightIcon: React.createElement(Chevron, { direction: isOpen ? ChevronDirection.UP : ChevronDirection.DOWN }) },
            React.createElement(Text, { ...rest, whiteSpace: "pre-wrap", isTruncated: true }, selectedOption?.[nameField]
                ? removeTagsFromSmartText(selectedOption[nameField])
                : defaultText)),
        React.createElement(CustomSelectOptions, { groups: groups, nameField: nameField, onChange: onChange })));
};
export default CustomSelect;
